import React from 'react';
import PropTypes from 'prop-types';
import ConvertedPrice from '../styled/ConvertedPrice';

const ApproximatedConvertedPrice = ({ formattedPrice }) =>
  formattedPrice ? <ConvertedPrice data-cy="price-approx-gbp">Approx. {formattedPrice}</ConvertedPrice> : null;

ApproximatedConvertedPrice.propTypes = {
  formattedPrice: PropTypes.string.isRequired,
};

export default ApproximatedConvertedPrice;
